<template>
    <ListadoControlDeAccesos
        :fields="fields"
        :controlAcessos="controlAcessosEntradas"
        :filtros="filtros"
        @getcontrolAcessos="getControlAcessosEntradas"
        :loading="loading"
        :metodos_pagos="metodos_pago_eventos"
    />
</template>

<script>
    import ListadoControlDeAccesos from "@/components/backend/eventos/sesiones/informe/ListadoControlDeAccesos.vue";
    export default {
        data() {
            return {
                evento_id :this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                fields: [
                    { key: "precio", label: "Precio"},
                    { key: "zona", label: "Zona"},
                    { key: "fila", label: "Fila"},
                    { key: "asiento", label: "Asiento"},
                    { key: "fecha", label: "Fecha / Hora de acceso"},
                    { key: "nombre", label: "Nombre"},
                    { key: "dni", label: "dni"},
                    { key: "telefono", label: "Teléfono"},
                    { key: "qr_code", label: "Qr code"},
                    { key: "concepto", label: "Concepto"},
                    { key: "metodo_pago", label: "Metodo de Pago"},
                    { key: "puerta_acceso", label: "Puerta acceso"},
                    { key: "verifica", label: "Validada"}
                ],
                controlAcessosEntradas: {
                    data: [],
                    meta: {
                        current_page: 1,
                        from: 1,
                        last_page: 1,
                        path: "",
                        per_page: 10,
                        to: 1,
                        total: 1,
                    },
                },
                filtros: {
                    per_page: 10,
                    page: 1,
                    search: "",
                    status: "",
                    currentPage: 1,
                    rows: 0,
                    numPage: 10,
                    metodo_pago: ""
                },
                loading: false,
                metodos_pago_eventos: [],
            }
        },
        created() {
            this.metodos_pago_eventos = this.teatro.metodos_pago_eventos;
        },
        methods: {
            getControlAcessosEntradas() {
                this.loading = true;
                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        evento_id: this.evento_id,
                        status: this.filtros.status,
                        search : this.filtros.search,
                        page : this.filtros.page,
                        per_page : this.filtros.numPage,
                        metodo_pago: this.filtros.metodo_pago,
                    },
                    sesion_id: this.sesion_id,
                    evento_id: this.evento_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.informe.control-accesos.entradas'), params).then(res => {
                    this.filtros.rows = res.data.meta.last_page;
                    this.filtros.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                    this.filtros.currentPage = res.data.meta.current_page;
                    this.controlAcessosEntradas = res.data
                }).finally(() => (this.loading = false))
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        components: {
            ListadoControlDeAccesos
        },
    }
</script>